document.addEventListener('DOMContentLoaded', function() {
  const makeSelect = document.getElementById('machine-make');
  const modelSelect = document.getElementById('machine-model');
  const form = document.getElementById('pin-query-form');
  const resultsContainer = document.getElementById('results-container');
  const noResultsMessage = document.getElementById('no-results-message');

  const csvUrl = 'https://cdn.shopify.com/s/files/1/0296/9658/9957/files/Hitch_Specs_All_Combined.csv?v=1755648991';
  let csvData = [];

  // A more robust CSV parsing function
  function parseCSV(text) {
    const lines = text.split(/\r?\n/);
    const result = [];
    const header = lines[0].split(',').map(h => h.trim().toLowerCase());
    
    for (let i = 1; i < lines.length; i++) {
      let line = lines[i].trim();
      if (!line) continue;

      const row = line.match(/(?:"[^"]*"|[^,])+/g);
      if (!row || row.length !== header.length) continue;

      const obj = {};
      row.forEach((value, index) => {
        let cleanValue = value.replace(/^"|"$/g, '').trim();
        obj[header[index]] = cleanValue;
      });
      result.push(obj);
    }
    return result;
  }

  // Function to fetch and process the CSV data
  function fetchAndParseCsv() {
    fetch(csvUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(csvText => {
        csvData = parseCSV(csvText);
        populateMakeDropdown();
      })
      .catch(error => {
        console.error('Error fetching or parsing CSV data:', error);
      });
  }

  // Function to populate the 'Make' dropdown
  function populateMakeDropdown() {
    const uniqueMakes = [...new Set(csvData.map(item => item.make))].sort();
    makeSelect.innerHTML = '<option value="">-- Select Make --</option>';
    uniqueMakes.forEach(make => {
      const option = document.createElement('option');
      option.value = make;
      option.textContent = make;
      makeSelect.appendChild(option);
    });
  }

  // Event listener for the 'Make' dropdown
  makeSelect.addEventListener('change', function() {
    const selectedMake = this.value;
    modelSelect.innerHTML = '<option value="">-- Select Model --</option>';

    if (selectedMake) {
      const uniqueModels = [...new Set(
        csvData.filter(item => item.make === selectedMake)
        .map(item => item.model)
      )].sort();

      uniqueModels.forEach(model => {
        const option = document.createElement('option');
        option.value = model;
        option.textContent = model;
        modelSelect.appendChild(option);
      });
    }
  });

  // Event listener for form submission
  form.addEventListener('submit', function(event) {
    event.preventDefault();

    const selectedMake = makeSelect.value;
    const selectedModel = modelSelect.value;
    resultsContainer.style.display = 'none';
    noResultsMessage.style.display = 'none';

    if (selectedMake && selectedModel) {
      const foundItem = csvData.find(item => item.make === selectedMake && item.model === selectedModel);

      if (foundItem) {
        const formattedString = `${foundItem['pin diameter']}P/${foundItem['pin centre']}C/${foundItem['dipper arm']}E`;
        document.getElementById('formatted-results').textContent = formattedString;
        resultsContainer.style.display = 'block';
      } else {
        noResultsMessage.style.display = 'block';
      }
    } else {
      noResultsMessage.style.display = 'block';
    }
  });

  // Fetch the data and populate the dropdowns on page load
  fetchAndParseCsv();
});